import { render, staticRenderFns } from "./ExchangeOrderList.vue?vue&type=template&id=39579a1a&scoped=true&lang=pug&"
import script from "./ExchangeOrderList.vue?vue&type=script&lang=js&"
export * from "./ExchangeOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeOrderList.vue?vue&type=style&index=0&id=39579a1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39579a1a",
  null
  
)

export default component.exports